/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { FileBlock } from "src/classes/block/block-types";

interface Props {
  block: FileBlock;
  disableMouse: boolean;
}

export function AudioWidget({ block, disableMouse }: Props) {
  return (
    <AudioWidgetWrapper style={{ pointerEvents: disableMouse ? "none" : "auto" }}>
      <audio controls>
        <source src={block.fileURL} />
      </audio>
    </AudioWidgetWrapper>
  );
}

const AudioWidgetWrapper = styled.div`
  margin-top: 35px;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  overflow: hidden;
  transform: scale(0.9);
  @media print {
    display: none;
  }
`;
